import React from 'react';
import {Route} from 'react-router-dom';
import AsyncTerms from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <Route key="/business/terms" element={<BlankLayout />}>
    <Route path="business/terms" element={<AsyncTerms />} />
  </Route>
);
